import React from 'react';
import ReactDOM from 'react-dom';
import App from './components/app';
import * as serviceWorker from './service-worker';
import { Router } from 'react-router-dom';
import "./index.scss";
import { Provider } from 'react-redux';
import { store } from "./helpers";
import { history } from "./helpers";

ReactDOM.render(
    <Router history={history}>
        <Provider store={store}>
            <App />
        </Provider>
    </Router>,
    document.getElementById('root')
);

serviceWorker.unregister();